import { LoadingBackdrop } from "@wesr/wesr-design-system";
import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";
import PublicLayout from "./layouts/PublicLayout";
import PublicMiddleware from "./middlewares/PublicMiddleware";

const NotFound = lazy(() => import("./pages/NotFound"));
const Applications = lazy(() => import("./pages/Applications"));
const CountryProfiles = lazy(() => import("./pages/CountryProfiles"));
const DataAnalysis = lazy(() => import("./pages/DataAnalysis"));
const DataCatalogue = lazy(() => import("./pages/DataCatalogue"));
const DataCatalogueDetails = lazy(() => import("./pages/DataCatalogueDetails"));
const Homepage = lazy(() => import("./pages/Homepage"));
const KnowledgeHub = lazy(() => import("./pages/KnowledgeHub"));
const KnowledgeHubDetails = lazy(() => import("./pages/KnowledgeHubDetails"));
const RouteError = lazy(() => import("./pages/RouteError"));
const UNEPLab = lazy(() => import("./pages/UNEPLab"));
const UNEPLabDetails = lazy(() => import("./pages/UNEPLabDetails"));

export const router = createBrowserRouter([
  {
    path: "/",
    element: <PublicMiddleware landingPage="/" />,
    children: [
      {
        element: <PublicLayout />,
        errorElement: (
          <Suspense fallback={<LoadingBackdrop />}>
            <RouteError />
          </Suspense>
        ),
        children: [
          {
            index: true,
            element: (
              <Suspense fallback={<LoadingBackdrop />}>
                <Homepage />
              </Suspense>
            ),
          },
          {
            path: "applications",
            element: (
              <Suspense fallback={<LoadingBackdrop />}>
                <Applications />
              </Suspense>
            ),
          },
          {
            path: "data-analysis",
            element: (
              <Suspense fallback={<LoadingBackdrop />}>
                <DataAnalysis />
              </Suspense>
            ),
          },
          {
            path: "data-catalogue",
            element: (
              <Suspense fallback={<LoadingBackdrop />}>
                <DataCatalogue />
              </Suspense>
            ),
          },
          {
            path: "data-catalogue/:datasetId",
            element: (
              <Suspense fallback={<LoadingBackdrop />}>
                <DataCatalogueDetails />
              </Suspense>
            ),
          },
          {
            path: "country-profiles",
            element: (
              <Suspense fallback={<LoadingBackdrop />}>
                <CountryProfiles />
              </Suspense>
            ),
          },
          {
            path: "knowledge-hub",
            element: (
              <Suspense fallback={<LoadingBackdrop />}>
                <KnowledgeHub />
              </Suspense>
            ),
          },
          {
            path: "knowledge-hub/:cardId",
            element: (
              <Suspense fallback={<LoadingBackdrop />}>
                <KnowledgeHubDetails />
              </Suspense>
            ),
          },
          {
            path: "unep-lab",
            element: (
              <Suspense fallback={<LoadingBackdrop />}>
                <UNEPLab />
              </Suspense>
            ),
          },
          {
            path: "unep-lab/:cardId",
            element: (
              <Suspense fallback={<LoadingBackdrop />}>
                <UNEPLabDetails />
              </Suspense>
            ),
          },
          {
            path: "*",
            element: (
              <Suspense fallback={<LoadingBackdrop />}>
                <NotFound />
              </Suspense>
            ),
          },
        ],
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
]);
